<template>
  <div class="container-fluid my-3 target" style="min-height:50vh">
    <popUp v-if="toggle" v-on:doClose="close" :size="'large'">
      <div class="pop-title" slot="title">
      </div>
      <div slot="title">
        <h1 class="mx-3 mb-2" style="font-weight:600">能力雷達圖</h1>
      </div>
      <div slot="left-box" class="info-main mt-3 d-flex  align-items-center  justify-content-center rwd-hide" v-if="datasets" >
        <RadarChart class=" m-auto" :datasets="datasets" />
      </div>
      <div slot="right-box" class=" mt-3 d-flex  align-items-center  justify-content-center " v-if="datasets" >
        <div class="info-main">
          <h4 class="mb-3" style="font-weight:600">平均分數: {{ radarInfo.Score }}</h4>
          <span>口說練習評估結果如下:</span>
          <ul
            class="score-info list-group list-group-horizontal"
            v-for="([key, item], index) in orderedScores"
            :key="key"
          >
            <li style="min-width: 120px;max-width: 120px;" class="score-title list-group-item">{{ tableTranslate(key) }}</li>
            <li style="min-width: 120px;max-width: 120px;" class="score score-content list-group-item">{{ item }}</li>
          </ul>
        </div>
      </div>
      <div class="radarInfo my-3 rwd-hide" v-if="radarInfo" slot="feedback">
        <hr>
        <!-- <button type="button" @click="playAudio('original', currentNo)" class="btn btn-outline-secondary mx-2">課程音檔</button>
        <button type="button" @click="playAudio('audio', currentNo)" class="btn btn-outline-secondary">我的錄音</button> -->
        <span class="badge badge-success">良好</span>
        <span class="badge badge-warning mx-2">尚可</span>
        <span class="badge badge-danger">再加油</span>
        <div class="pointer mt-2">
          <span style="font-weight:600;weight:200px">課程句子:</span>
          {{radarInfo.Text}}
        </div>
        <div>
          <span style="font-weight:600">我的聲音: </span>
          <span v-html="applyColorToWords(radarInfo.Text, radarInfo.Words)"></span>
        </div>
      </div>
    </popUp>
    <div class="row">
      <div class="col-12">
        <table class="rwd-table">
          <tbody>
            <tr>
              <th>句子</th>
              <th>第一次分數</th>
              <th>最高分數</th>
              <th>最新分數</th>
              <th>練習次數</th>
              <th>能力雷達圖</th>
              <th>最新錄音</th>
            </tr>
            <tr v-for="(item, index) in record" :key="index">
              <td class="rwd-td" data-th="句子"  @click="playAudio('original',item.no)">
                {{item.text}}
                <audio :id="`originalAudio${item.no}`">
                  <source :src="item.audio" type="audio/wav" />
                </audio>
              </td>
              <td data-th="第一次分數">
                {{item.first_score}}
              </td>
              <td data-th="最高分數">
                {{item.highest_score}}
              </td>
              <td data-th="最新分數">
                {{item.score}}
              </td>
              <td data-th="練習次數">
                {{item.times}}
              </td>
              <td data-th="能力雷達圖">
                <font-awesome-icon @click="openRadarInfo(item.data, item.no)"  class="pointer" style="color:black" size="2x" :icon="['fa', 'image']" />
              </td>
              <td data-th="最新錄音">
                <audio v-if="item.data" :id="`audio${item.no}`" controls>
                  <source :src="item.data.AudioUrl" type="audio/wav" />
                </audio>
              </td>
            </tr>
          </tbody>
        </table>
        <audio id="record" >
          <source :src="audio_url" type="audio/wav">
        </audio>
      </div>
		</div>
  </div>
</template>
<script>
// @ is an alias to /src
import popUp from '../components/PopUp.vue'
import RadarChart from '../components/RadarChart.vue'
import api from '../store/api'
export default {
  name: 'VoiceRecord',
  data () {
    return {
      toggle: false,
      lessonSummary: [],
      record: {},
      abilities: {},
      audio_url: '',
      radarInfo: null,
      feedback: null
    }
  },
  computed: {
    groupId () {
      return this.$route.params.groupId
    },
    lessonId () {
      return this.$route.params.lessonId
    },
    studentId () {
      return this.$route.params.studentId
    },
    orderedScores() {
      const order = [
        'AccuracyScore',
        'FluencyScore',
        'CompletenessScore',
        'ProsodyScore'
      ]
      return order.map(key => [key, this.radarInfo.Scores[key]])
    }
  },
  mounted () {
    this.getRecord()
  },
  methods: {
    async getRecord() {
      const { data } = await api.get(`records/groups/${this.groupId}/voices/courses/${this.lessonId}/students/${this.studentId}`)
      this.record = data.data
    },
    openRadarInfo (el, no) {
      this.pauseAll()
      this.radarInfo = el
      // this.mergedFeedback(el)
      this.currentNo = no
      if (el.Scores) {
        this.openRadarChart(el.Scores)
      } else {
        alert('目前版本不支持MentorAi')
      }
    },
    openRadarChart (el) {
      const data = {
        'PronScore' : 0,
        'AccuracyScore': 0,
        'CompletenessScore': 0,
        'FluencyScore': 0,
        'ProsodyScore': 0
      }
      const order = [
        'PronScore',
        'AccuracyScore',
        'CompletenessScore',
        'FluencyScore',
        'ProsodyScore'
      ]
      const arr = order.map(key => el[key] ?? data[key])
      this.datasets = {
        labels: [ '平均分數', '準確度', '流暢度', '完整性', '韻律'],
        datasets: [
          {
            label: '',
            backgroundColor: '#f87979a5',
            radius: 6,
            pointRadius: 6,
            pointBorderWidth: 3,
            data: arr,
            borderColor: '#f87979',
          }
        ]
      }
      this.toggle = true
    },
    close (close) {
      this.toggle = close
      this.radarInfo = null
      this.currentNo = 0
      this.pauseAll()
    },
    playRecord (item) {
      this.audio_url = ''
      this.audio_url = item
      let audio = document.getElementById(`record`)
      this.pauseAll()
      audio.load()
      audio.play()
      // const playPromise = media.play();
      // if (playPromise !== null){
      //     playPromise.catch(() => { media.play(); })
      // }
    },
    pauseAll () {
      const audios = document.getElementsByTagName('audio')
      const self = this
      const allAudios = []
      allAudios.forEach.call(audios, function (i) {
        // 将audios中其他的audio全部暂停
        i.currentTime = 0
        i !== self && i.pause()
      })
    },
    getPartNameFromIndex (index) {
      switch (index) {
        case 0:
          return 'speed'
        case 1:
          return 'phrasing'
        case 2:
          return 'pronunciation'
        case 3:
          return 'loudness'
        case 4:
          return 'rhythm'
        case 5:
          return 'intonation'
        default:
          return 'unknown'
      }
    },
    tableTranslate (el) {
      switch (el) {
        case 'AccuracyScore':
          return '精確度'
        case 'FluencyScore':
          return '流暢度'
        case 'CompletenessScore':
          return '完整性'
        case 'ProsodyScore':
          return '韻　律'
        default:
          return '未知'
      }
    },
    mapErrorTypeToStatus (errorType) {
      switch (errorType) {
        case "None":
          return 0 // green
        case "Mispronunciation":
        case "Monotone":
          return 1 // orange
        case "Omission":
          return 2 // red
        default:
          return -1 // 不顯示
      }
    },
    applyColorToWords(text, wordStatus) {
      const statusToColor = {
        "0": "green",
        "1": "orange",
        "2": "red"
      }
      // 建立一個可變的 wordStatus 副本，以便我們可以使用和移除項目
      const availableWordStatus = [...wordStatus]
      // 拆開字與標點
      const wordsWithPunctuation = text.match(/[\w'$-]+|[.,!?;:]/g)
      if (!wordsWithPunctuation) {
        return text // 如果沒有匹配到任何單字或標點，直接返回原文本
      }
      console.log(wordsWithPunctuation)
      const colorizedWords = wordsWithPunctuation.map(word => {
        if (/[\w'$-]+/.test(word)) {
          // 尋找第一個匹配的、尚未使用的狀態的索引
          const statusIndex = availableWordStatus.findIndex(
            item => item.Word.trim().toLowerCase() === word.trim().toLowerCase() && item.ErrorType !== "Insertion"
          )
          if (statusIndex !== -1) {
            // 取得狀態物件，並將其從可用列表中移除
            const [statusObj] = availableWordStatus.splice(statusIndex, 1)
            const status = this.mapErrorTypeToStatus(statusObj.ErrorType)
            if (status !== null && status !== -1) {
              const color = statusToColor[status.toString()]
              return `<span style="color: ${color};">${word}</span>`
            }
          }
          return word
        } else {
          return word // 標點符號保留
        }
      })
      return colorizedWords.join(' ')
    },
    mergedFeedback (el) {
      const part_feedback = el.part_feedback
      const part_scoresArray = el.part_score
      const part_scores = {}
      console.log(part_feedback,part_scoresArray)
      part_scoresArray.forEach((score, index) => {
        const partName = this.getPartNameFromIndex(index)
        part_scores[partName] = score
      })
      const mergedFeedback = {}
      for (const part in part_feedback) {
        if (part_scores.hasOwnProperty(part)) {
          mergedFeedback[part] = {
            feedback: part_feedback[part],
            score: part_scores[part]
          }
        }
      }
      console.log(mergedFeedback)
      this.feedback = mergedFeedback
    }
  },
  components: {
    RadarChart,
    popUp
  }
}
</script>
<style lang="scss" scoped>
@import "../assets/styles/color.scss";
  .pop-info-box {
    margin: 10px;
    text-align: center;
    .title {
      padding: 3px;
      max-width: 200px;
      background-color: rgb(24, 97, 255);
      font-weight: bold;
      color: #fff;
    }
    .content {
      padding: 10px;
      max-width: 200px;
      color: #51A8DD;
      border: 1px #51A8DD solid;
    }
  }
  table {
    border-collapse: collapse;
    width: 100%;
    overflow: auto;
  }
  th {
    overflow:hidden;
    border: 4px solid #fff;
    color: #fff;
    text-align: center !important;
    padding: 8px;
  }
  tr:nth-child(even){
    background-color:#e8e8e8 !important;
  }
  /*表格中的奇數對 tr*/
  tr:nth-child(odd){
    background-color:#d8d8d8 !important;
  }
  td {
    font-weight: bold;
    // background-color: rgb(230, 230, 230);
    border: 4px solid #fff;
    text-align: center !important;
    padding: 8px;
  }
  .th-title {
    width: 220px;
    height: 120px;
    padding: 0 !important;
    position: relative;
    img {
      top:0;
      left: -5px;
      position: absolute;
      width: 105%;
      height: 100%;
    }
  }
  .title-box {
    margin-bottom: 20px;
    border-top: #aaa solid 1px;
    border-bottom: #aaa solid 1px;
    padding: 10px 0;
    .title {
      color: #aaa;
      margin: 0 50px 0 0;
      cursor: pointer;
    }
    .active {
      color: black;
    }
  }
  .score-info {
    font-size: 1.2rem;
    .score-title {
      border-color: #fff !important;
      border-width: 3px !important;
      background-color: #418BCA;
      color: #fff;
    }
    .score {
      font-weight: 600;
    }
    .score-content {
      background-color: #E9F8FF;
      border-color: #fff !important;
      border-width: 3px !important;
    }
  }
  .radarInfo {
    font-size: 1.25rem;
  }
  .good {
    color: green;
  }
  .bad {
    color: red;
  }
  .normal {
    color:orange;
  }
  .wrong {
    color: rgba(0, 0, 0, 0.4);
  }
  .rwd-table {
  margin: auto;
  min-width: 300px;
  max-width: 100%;
  border-collapse: collapse;
}

.rwd-table tr:first-child {
  border-top: none;
  background: $table-gray !important;
  color: #fff;
}

.rwd-table tr {
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  background-color: #f5f9fc;
}

.rwd-table tr:nth-child(odd):not(:first-child) {
  background-color: #ebf3f9;
}

.rwd-table th {
  display: none;
}

.rwd-table td {
  display: block;
}

.rwd-table td:first-child {
  margin-top: .5em;
}

.rwd-table td:last-child {
  margin-bottom: .5em;
}

.rwd-table td:before {
  content: attr(data-th) ": ";
  font-weight: bold;
  width: 120px;
  display: inline-block;
  color: #000;
}

.rwd-table th,
.rwd-table td {
  text-align: left;
}

.rwd-table tr {
  border-color: #bfbfbf;
}

.rwd-table th,
.rwd-table td {
  padding: .5em 1em;
}
@media screen and (max-width: 601px) {
  .rwd-table tr:nth-child(2) {
    border-top: none;
  }
  .rwd-td {
    display: block !important;
    background-color: #04a2d6;
  }
  td {
    border: 1px solid #ccc;
  }
  button  {
    display: none;
  }
}
.lesson-box {
  width: 80%;
}
.group-box {
  width: 20%;
}
.box {
  margin: 5px;
  padding: 10px;
  background-color: #044ed6;
  color: #fff;
}
@media screen and (min-width: 600px) {
  .rwd-table tr:hover:not(:first-child) {
    background-color: #d8e7f3;
  }
  .rwd-table td:before {
    display: none;
  }
  .rwd-table th,
  .rwd-table td {
    display: table-cell;
    padding: .25em .5em;
  }
  .rwd-table th:first-child,
  .rwd-table td:first-child {
    padding-left: 0;
  }
  .rwd-table th:last-child,
  .rwd-table td:last-child {
    padding-right: 0;
  }
  .rwd-table th,
  .rwd-table td {
    // padding: 1em !important;
  }
}
</style>

